<app-new-modal [showModal]="showError" title="ERROR" primaryButtonText="BACK" width="50%" (primaryAction)="goHome()"
	hideClose="true">
	<div style="margin-block: 40px;font-size: 18px;font-weight: 400;">
		{{ "SOMETHING_WENT_WRONG" | translate }}
	</div>
</app-new-modal>

<section>
	<div class="row page-title">
		<div style="margin-top: 60px;" class="container clear-padding text-center flight-title">
			<h3>{{ "VOUCHER" | translate }}</h3>
		</div>
	</div>
</section>

<div class="container voucher-container" *ngIf="agency && bookingDetails">
	<div class="voucher-pad">
		<div class="voucher-grid">
			<div style="font-weight: 500">
				<div class="voucher-title">
					{{ "VOUCHER" | translate }}: {{ bookingDetails.reference }}
				</div>
				<div>{{ "ORDER_DATE" | translate }}: {{ bookingDetails.bookingDate }}</div>
				<div style="font-size: 1.3rem; font-weight: bold; margin-top: 3px" [ngClass]="{
						confirmed: uppercaseStr(bookingDetails.status) == 'CONFIRMED',
						failed: uppercaseStr(bookingDetails.status) == 'CANCELED',
						pending: uppercaseStr(bookingDetails.status) == 'PENDING'
					}">
					{{ uppercaseStr(bookingDetails.status) | translate }}
				</div>
			</div>
			<div style="text-align: end;">
				<qr-code [value]="qrcodedata" [size]="200"></qr-code>
			</div>
		</div>
		<div class="container-section">
			<div class="s-title">
				{{ "BOOKING_DETAILS" | translate }}
			</div>
			<div class="res-details-grid">
				<div class="info-hotel-div">
					<table>
						<tbody>
							<tr *ngIf="bookingDetails.hotel?.info?.name">
								<td style="white-space: nowrap; width: 1%">
									{{ "HOTEL_NAME" | translate }} :
								</td>
								<td class="hotel-name wrap-text ">
									{{ bookingDetails.hotel.info.name }}
								</td>
							</tr>
							<tr *ngIf="bookingDetails.hotel?.info?.phone">
								<td>Tel :</td>
								<td class="wrap-text">
									{{ bookingDetails.hotel?.info?.phone }}
								</td>
							</tr>
							<tr *ngIf="bookingDetails.hotel?.info?.mail">
								<td>{{ "EMAIL" | translate }} :</td>
								<td class="wrap-text">
									{{ bookingDetails.hotel?.info?.mail }}
								</td>
							</tr>
							<tr>
								<td>{{ "NIGHTS" | translate }} :</td>
								<td>
									{{ getNights() }}
								</td>
							</tr>
							<tr>
								<td style="white-space: nowrap">{{ "CHECK_IN" | translate }} :</td>
								<td>
									{{ bookingDetails.hotel.checkIn }}
								</td>
							</tr>
							<tr>
								<td style="white-space: nowrap">{{ "CHECK_OUT" | translate }} :</td>
								<td>
									{{ bookingDetails.hotel.checkOut }}
								</td>
							</tr>
							<tr>
								<td>{{ "REF" | translate }} :</td>
								<td>
									{{ bookingDetails.internal_reference }}
								</td>
							</tr>
							<tr *ngIf="bookingDetails.provider_id == 'TRAVELGATE'">
								<td>{{ "TG_REF" | translate }} :</td>
								<td>
									{{ bookingDetails.travelgate_id }}
								</td>
							</tr>
							<tr>
								<td>{{ "AGENCY" | translate }} :</td>
								<td>
									{{ agency.name }}
								</td>
							</tr>
							<tr *ngIf="bookingDetails.hotel.address">
								<td>{{ "ADDRESS" | translate }} :</td>
								<td class="wrap-text">
									{{ bookingDetails.hotel.address }}
								</td>
							</tr>
							<tr class="print_hide" *ngIf="!bookingDetails.agency.hide_price_in_hotel_voucher">
								<td>{{ "TOTAL" | translate }} :</td>
								<td>
									{{ formatPrice(bookingDetails.total_price.total) }}
									{{ bookingDetails.total_price.currency }}
								</td>
							</tr>
							<tr class="print_hide" *ngIf="!bookingDetails.agency.hide_price_in_hotel_voucher">
								<td style="white-space: nowrap">{{ "REFUND" | translate }} :</td>
								<td>
									{{ formatPrice(bookingDetails.refundedAmount.total) }}
									{{ bookingDetails.refundedAmount.currency }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="info-room-div">
					<table>
						<thead>
							<tr>
								<th style="border-bottom: 2px solid #ddd">
									{{ "LODGING" | translate }}
								</th>
								<th style="border-bottom: 2px solid #ddd">
									{{ "BOARD" | translate }}
								</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="
									let room of bookingDetails.hotel.rooms;
									let roomIndex = index
								">
								<td>
									<div class="room-info">
										<div class="room-name">
											{{ room.name }}
										</div>
										<div *ngFor="let guestID of room['paxes']">
											{{ bookingDetails.hotel.paxes[guestID].firstname }}
											{{ bookingDetails.hotel.paxes[guestID].lastname }}
											({{ bookingDetails.hotel.paxes[guestID].type }})
											<span
												*ngIf="bookingDetails.hotel.paxes[guestID].age != null && (bookingDetails.hotel.paxes[guestID].type == 'CHD' || bookingDetails.hotel.paxes[guestID].type == 'INF')">({{bookingDetails.hotel.paxes[guestID].age}}
												an<span
													*ngIf="bookingDetails.hotel.paxes[guestID].age > 1">s</span>)</span>
										</div>
									</div>
								</td>
								<td style="width: 40%" *ngIf="room.rates.length > 0">
									{{ room.rates[0].board }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="container-section" *ngIf="
				bookingDetails.hotel.rooms.length > 0 &&
					bookingDetails.hotel.rooms[0].rates.length > 0 &&
					bookingDetails.hotel.rooms[0].rates[0].cancellation_policies.length > 0;
				else elseBlock
			">
			<div class="s-title">
				{{ "CONDITION_VOUCHER" | translate }}
			</div>
			<div style="margin-top: 10px">
				<ul>
					<li *ngFor="let room of bookingDetails.hotel.rooms; let rIndex = index">
						<div style="font-weight: bold">
							{{ "ROOM" | translate }} : {{ room.name }}
						</div>
						<ul *ngFor="let rate of room.rates">
							<li *ngFor="let policy of rate.cancellation_policies">
								<span *ngIf="policy['from']">
									{{ "FROM1" | translate }} {{ policy["from"] }}
								</span>

								<span *ngIf="policy['to']">
									{{ "TO2" | translate }} {{ policy["to"] }}
								</span>
								<span> : </span>

								<span *ngIf="!policy['chargeable']" style="font-weight: 500; color: green">
									{{ "FREE" | translate }}
								</span>
								<span *ngIf="policy['chargeable']" style="color: crimson; font-weight: 500">
									{{
									policy["fees_type"] == "FIXED_PRICE"
									? formatPrice(policy["price"]["total"]) +
									"
									" +
									policy["price"]["currency"]
									: ""
									}}
									{{
									policy["fees_type"] == "PERCENT_PRICE"
									? policy["percent_price"] + "% du montant de la facture"
									: ""
									}}
									{{
									policy["fees_type"] == "NIGHTS"
									? policy["nights"] + " " + ("NIGHTS" | translate)
									: ""
									}}
								</span>
							</li>
						</ul>
					</li>
				</ul>
				<div style="font-weight: bold; padding: 0 10px">
					{{ "DATE_TIME_LOCAL_ZONE" | translate }}
				</div>
			</div>
		</div>

		<ng-template #elseBlock>
			<div class="container-section">
				<div class="s-title">
					{{ "CONDITION_VOUCHER" | translate }}
				</div>
				<div style="margin-top: 10px">
					<ul>
						<li *ngFor="
								let policy of bookingDetails.cancellationPolicies
									.cancellationPolicies;
								let policyIndex = index
							">
							<span *ngIf="policy['from']">
								{{ "FROM1" | translate }} {{ policy["from"] }}
							</span>

							<span *ngIf="policy['to']">
								{{ "TO2" | translate }} {{ policy["to"] }}
							</span>
							<span> : </span>

							<span *ngIf="!policy['chargeable']" style="font-weight: 500; color: green !important">
								{{ "FREE" | translate }}
							</span>
							<span *ngIf="policy['chargeable']" style="color: crimson !important; font-weight: 500">
								{{
								policy["fees_type"] == "FIXED_PRICE"
								? formatPrice(policy["price"]["total"]) +
								"
								" +
								policy["price"]["currency"]
								: ""
								}}
								{{
								policy["fees_type"] == "PERCENT_PRICE"
								? policy["percent_price"] + "% du montant de la facture"
								: ""
								}}
								{{
								policy["fees_type"] == "NIGHTS"
								? policy["nights"] + " " + ("NIGHTS" | translate)
								: ""
								}}
							</span>
						</li>
					</ul>
					<div style="font-weight: bold; padding: 0 10px">
						{{ "DATE_TIME_LOCAL_ZONE" | translate }}
					</div>
				</div>
			</div>
		</ng-template>

		<div class="container-section" *ngIf="bookingDetails.comments && bookingDetails.comments != '.'"
			[ngClass]="{ print_hide: !bookingDetails.comments || bookingDetails.comments == '.' }">
			<div class="s-title">
				{{ "NOTES_VOUCHER" | translate }}
			</div>
			<div *ngIf="
					bookingDetails.supplier_name &&
					bookingDetails.provider != 'CR' &&
					bookingDetails.supplier_vat_number
				" style="margin-top: 10px; padding: 0 10px; color: red; font-weight: bold;">
				Payable through <b> {{ bookingDetails.supplier_name }} </b>, acting as agent for the
				service operating company {{ bookingDetails.supplier_vat_number }}, details of which
				can be provided upon request. VAT:
				<b> {{ bookingDetails.supplier_vat_number }} </b> Reference:
				<b> {{ bookingDetails.reference }} </b>
			</div>

			<div style="margin-top: 10px; padding: 0 10px;  color: red; font-weight: bold;"
				[innerHTML]="bookingDetails.comments"></div>
		</div>

		<div style="margin-top: 1rem;display: flex;align-items: center;justify-content: center;">
			<div class="" class="voucher-logo"></div>
		</div>
	</div>
</div>